export interface ReloadParams {
	readonly preventLoop?: boolean;
	readonly preventLoopMinimalIntervalMs?: number;
}

const MINIMAL_RELOAD_INTERVAL_MS = 5000;

export function reloadPage(params?: ReloadParams): void {
	const { preventLoop = true, preventLoopMinimalIntervalMs = MINIMAL_RELOAD_INTERVAL_MS } = params ?? {};

	if (preventLoop) {
		const lastReload = sessionStorage.getItem('lastReload');
		const now = Date.now();

		if (lastReload && now - Number(lastReload) < preventLoopMinimalIntervalMs) {
			return;
		}

		sessionStorage.setItem('lastReload', now.toString());
	}

	globalThis.location.reload();
}
